a.s.locationpicker = (function(){
	var my = {
		pick:function(cb,o){
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Select location',
				winbar_action_icon:'cog',
				winbar_action:function(){
					// Defined in ready to get popup token
				},
				ready:function(token){
					var win = $('#popupid_'+token);
					// Bind winbar action
					$('>.popupwinbar>.action>i[data-action="winbar_action"]',win).unbind('click').click(function(){
						a.location.list.popup({
							back:function(){
								my.search(win,token,'',0,cb);
							}
						});
					});
					// Show content
					tpl.run({tpl:'/tpl/shared/locationpicker/main.ejs?v='+v,data:{},cb:function(c){
						$('>.ic',win).empty().append(c).ready(function(){
							// Load location list
							my.search(win,token,'',0,cb);
						});
					}});
				}
			});
		},
		search:function(win,token,q,offset,cb){
			var area = $('div[data-area="result"]',win);
			var pagination_area = $('div[data-area="pagination"]',win);
			var msgarea = $('div.msg',win);
			area.empty();
			a.loader.area.create(msgarea);
			$.ajax({
				type:'GET',
				url:'/api/location/list/',
				data:{
					limit:15,
					sort:'name',
					direction:'down',
					offset:offset,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success && result.list) {
						tpl.run({tpl:'/tpl/shared/locationpicker/list.ejs?v='+v,data:result,cb:function(content){
							area.empty().append(content);
							// Bind click callback
							$('div[data-area="result"] table tr',win).unbind('click').click(function(){
								if (result.list[$(this).attr('data-index')].id==$(this).attr('data-lid')) {
									// Return result
									cb(result.list[$(this).attr('data-index')]);
									// Close window
									window.history.back();
								}
								else {
									a.s.growl.create('Error','Unable to find correct location, please reload and try again',{});
								}
							});
						}});
						tpl.run({
							tpl:'/tpl/shared/locationpicker/pagination.ejs?v='+v,
							data:result.pagination,
							cb:function(str){
								$(pagination_area).empty().append(str);
								// Bind navigation buttons
								$('a[data-action="pagination-first"]',win).unbind('click').click(function(){
									my.search(win,token,q,0,cb);
								});
								$('a[data-action="pagination-previous"]',win).unbind('click').click(function(){
									my.search(win,token,q,result.pagination.prev_page,cb);
								});
								$('a[data-action="pagination-next"]',win).unbind('click').click(function(){
									my.search(win,token,q,result.pagination.next_page,cb);
								});
								$('a[data-action="pagination-goto"]',win).unbind('click').click(function(){
									my.search(win,token,q,$(this).attr('data-offset'),cb);
								});
							}
						});
					}
					else {
						tpl.run({tpl:'/tpl/shared/locationpicker/nohits.ejs?v='+v,data:{},cb:function(content){
							$(area).empty();
							$(msgarea).empty().append(content);
						}});
					}
				}
			}).done(function(){
				msgarea.empty();
			});
		}
	}
	return my;
}());